import { useMemo } from "react"
import { useTranslation } from "@/hooks/use-translation"
import { roleHintKey, roleLabelKey, type RoleScope } from "@/lib/roles"

type RoleLabelKey = "company:companyRoles.owner"
type RoleHintKey = "company:roleHints.company.owner"

export function useRoleText() {
  const { t } = useTranslation("company")
  return useMemo(
    () => ({
      label: (scope: RoleScope, role: string) => t(roleLabelKey(scope, role) as RoleLabelKey, { defaultValue: role }),
      hint: (scope: RoleScope, role: string) => t(roleHintKey(scope, role) as RoleHintKey, { defaultValue: "" }),
    }),
    [t],
  )
}
